import { PackingMaterialPricesRequest, PackingMaterialPricesResponseModel, ProductPackStyleReq } from "@gtpl/shared-models/masters";
import { connection } from "..";
import axios from "axios";

export class PackingMaterialPriceService {
    activatedeActivate(data: PackingMaterialPricesRequest) {
        throw new Error('Method not implemented.');
      }
      URL = connection.DEPLOY_URL + '/packing-material-prices';
    
      async createPackingMaterialPrices(req:PackingMaterialPricesRequest): Promise<PackingMaterialPricesResponseModel> {
        return await axios.post(this.URL + '/createPackingMaterialPrices', req)
          .then(res => {
            return res.data
          })
      }
      async getAllPackingMaterialPricesInfo(): Promise<PackingMaterialPricesResponseModel> {
        return await axios.post(this.URL + '/getAllPackingMaterialPricesInfo')
          .then(res => {
            return res.data
          })
      }

      async getPriceAgainstProductPackStyle(req:ProductPackStyleReq): Promise<PackingMaterialPricesResponseModel> {
        return await axios.post(this.URL + '/getPriceAgainstProductPackStyle',req)
          .then(res => {
            return res.data
          })
      }
}